import { action } from 'satcheljs';

export const contactSupport = action('contactSupport');
